// extracted by mini-css-extract-plugin
export default {"impersonate-button":"CustomModal_impersonate-button__lYE69"};